<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_v"><b>Contents</b></a></p><a id="page_v">
</a><p class="toc"><a id="page_v"></a><a href="#/xhtml/06_Foreword">Series Foreword</a></p>
<p class="toca"><i>Patrick J. Deneen</i></p>
<p class="toct"><a href="#/xhtml/07_Introduction">Introduction</a></p>
<p class="toca"><i>Susan J. McWilliams</i></p>
<p class="tocp"><a href="#/xhtml/08_Part01"><b>Part I. Collective Consciousness and Community</b></a></p>
<p class="toc"><a href="#/xhtml/09_Chapter01">1. “A Most Disagreeable Mirror”: Race Consciousness as Double Consciousness</a></p>
<p class="toca"><i>Lawrie Balfour</i></p>
<p class="toc"><span href="#/xhtml/10_Chapter02" title="Link target outside of Sample">2. The Race of a More Perfect Union: James Baldwin, Segregated Memory, and the Presidential Race</span></p>
<p class="toca"><i>P. J. Brendese</i></p>
<p class="toc"><span href="#/xhtml/11_Chapter03" title="Link target outside of Sample">3. James Baldwin and the Politics of Disconnection</span></p>
<p class="toca"><i>Susan J. McWilliams</i></p>
<p class="toc"><span href="#/xhtml/12_Chapter04" title="Link target outside of Sample">4. What William F. Buckley Jr. Did Not Understand about James Baldwin: On Baldwin’s Politics of Freedom</span></p>
<p class="toca"><i>Nicholas Buccola</i></p>
<p class="tocp"><span href="#/xhtml/13_Part02" title="Link target outside of Sample"><b>Part II. Prophecy, Religion, and Truth</b></span></p>
<p class="toc"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample">5. Baldwin, Prophecy, and Politics</span></p>
<p class="toca"><i>George Shulman</i></p>
<p class="toc"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample">6. The Negative Political Theology of James Baldwin</span></p>
<p class="toca"><i>Vincent Lloyd</i></p>
<p class="toc"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample">7. <i>Go Tell It on the Mountain:</i> James Baldwin and the Politics of Faith</span></p>
<p class="toca"><i>Wilson Carey McWilliams</i></p>
<p class="tocp"><a id="page_vi"></a><span href="#/xhtml/17_Part03" title="Link target outside of Sample"><b>Part III. The Individual Life, the Interior Life, the Unexamined Life</b></span></p>
<p class="toc"><span href="#/xhtml/18_Chapter08" title="Link target outside of Sample">8. Socrates in a Different Key: James Baldwin and Race in America</span></p>
<p class="toca"><i>Joel Alden Schlosser</i></p>
<p class="toc"><span href="#/xhtml/19_Chapter09" title="Link target outside of Sample">9. Crossing Identitarian Lines: Women’s Liberation and James Baldwin’s Early Essays</span></p>
<p class="toca"><i>Brian Norman</i></p>
<p class="toc"><span href="#/xhtml/20_Chapter10" title="Link target outside of Sample">10. “Where the People Can Sing, the Poet Can Live”: James Baldwin, Pragmatism, and Cosmopolitan Humanism</span></p>
<p class="toca"><i>Ulf Schulenberg</i></p>
<p class="toc"><span href="#/xhtml/21_Chapter11" title="Link target outside of Sample">11. Baldwin’s Individualism and Critique of Property</span></p>
<p class="toca"><i>Jack Turner</i></p>
<p class="tocp"><span href="#/xhtml/22_Part04" title="Link target outside of Sample"><b>Part IV. Violence and Vision</b></span></p>
<p class="toc"><span href="#/xhtml/23_Chapter12" title="Link target outside of Sample">12. James Baldwin on Violence and Disavowal</span></p>
<p class="toca"><i>Lisa Beard</i></p>
<p class="toc"><span href="#/xhtml/24_Chapter13" title="Link target outside of Sample">13. James Baldwin and Black Lives Matter</span></p>
<p class="toca"><i>Eddie S. Glaude Jr</i>.</p>
<p class="toc"><span href="#/xhtml/25_Chapter14" title="Link target outside of Sample">14. “Tell Him I’m Gone”: On the Margins in High-Tech City</span></p>
<p class="toca"><i>Rachel Brahinsky</i></p>
<p class="toct"><span href="#/xhtml/26_Acknowledgement" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/27_Bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc"><span href="#/xhtml/28_Contributors" title="Link target outside of Sample">List of Contributors</span></p>
<p class="toc"><span href="#/xhtml/29_Index01" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?8222507c